import React, { Component } from 'react';
import { connect } from "react-redux";
import CustomSearchableSelectWrapper from '../../../../common/custom-form/custom-searchable-select-wrapper.component';
import { EXTRACT_TEMPLATE_MODULES, FILE_NAME_TEMPLATE, MAX_LENGTH, CHARGE_MAPPING_UPLOAD_TYPES, UPLOAD_TYPES, CHARGE_MAPPING_FILE_LIMITATION } from '../../../../../constants/external-constants';
import ButtonIcon from "../../../../../components/button";
import { Button } from 'react-bootstrap';
import Translation from '../../../../common/translation/translation.component';
import DragDropUpload from '../../../../common/upload/drag-drop-upload/drag-drop-upload.component';
import { TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../../utils/helpers.utils";
import { chargeMappingAction } from '../../../../../store/external/invoice/invoice-upload/charge-mapping.reducer';
import store from '../../../../../store';
import { actions } from 'react-redux-form';
import { bindActionCreators } from 'redux';
import { NotificationModal } from "../../../../common/modal/notification-modal.component";
import { Loading } from "../../../../common/loading";
import '../charge-mapping-view.css';

class ChargeMappingView extends Component {
    constructor(props) {
        super(props);

        this.childRef = React.createRef();

        this.state = {
            vendor: null,
            uploadInProgress: false,
            isLoading:true,
            filterLoading:false,
            loadingLabel: "",
            errorModal: {
                show: false,
                title: "",
                message: ""
            },
        };
    }

    async componentDidMount(){     
        const {getVendorDetails, getChargeMappingUploadTypes, resetChargeMappingUploadForm }=this.props; 
        store.dispatch(actions.reset('chargeMappingForm.vendorId')); 
        store.dispatch(actions.reset('chargeMappingForm.chargeMappingUploadTypeId'));   
        await resetChargeMappingUploadForm(); 
        await getVendorDetails().then(()=>{ this.setState({isLoading:false})});
        await getChargeMappingUploadTypes().then(()=>{ this.setState({isLoading:false})});
    }

    async componentDidUpdate(prevProps) {
        if(this.props.chargeMappingForm.extractError !== prevProps.chargeMappingForm.extractError
            && this.props.chargeMappingForm.extractError == true)
        {
            this.toggleExtractErrorModal(this.props.chargeMappingForm.extractError, "Error", "Extract failed. No charge mapping uploaded");
        }
    }

    toLocaleLanguage = (key) => {
            const { locale } = this.props;
            if (locale === null || locale === '' || locale === undefined)
                return translation[translation['defaultLocaleLanguage']][key];
    
            return translation[locale][key];
        }

    handleChangeVendor = (id) => {
        store.dispatch(actions.change('chargeMappingForm.vendorId', id));
    }

    handleChangeUploadType = (id) => {
        store.dispatch(actions.change('chargeMappingForm.chargeMappingUploadTypeId', id));
    }

    onClickDownload = () => {
        if (window.confirm(this.toLocaleLanguage('export_alert_message'))) {
            //this.props.extractInventoryCircuits(id);
        }
    }
    onChangeExtractAlertMsg = (val, key) => {
        this.setState({
            extractAlertMsg: val
        });
    }

    handleDownloadTemplate = () => {
        const { downloadChargeMappingTemplate } = this.props;
        this.setState({
            filterLoading:true,
            loadingLabel:"Downloading"
        })
        if (window.confirm(this.toLocaleLanguage('export_alert_message'))) {
            downloadChargeMappingTemplate(EXTRACT_TEMPLATE_MODULES.chargeMappingTemplate, FILE_NAME_TEMPLATE.chargeMappingTemplate).then(()=>{ this.setState({filterLoading:false,
            loadingLabel:""})
        });;
        }  else {
            this.setState({filterLoading:false,
                loadingLabel:""})
        }     
    }

    handleSuccessProcess = (data) => {
        const { postExecuteProcess } = this.props;
        postExecuteProcess(data.UploadId);
        this.setState({
            uploadInProgress: false
        });
    }

    handleAddFiles = () => {
        this.forceUpdate();
    }

    handleRemoveFiles = () => {
        this.forceUpdate();
    }

    djsConfigParams = () => {
        const { chargeMappingForm } = this.props;
        const { vendorOptions } = this.props.chargeMappingUpload;

        var baseParams = {
            VendorDetailId: chargeMappingForm.vendorId,
            VendorName: vendorOptions?.find(i => i.Key == chargeMappingForm.vendorId)?.Value.replace('[Preferred]', '').trim(),
            ChargeMappingUploadTypeId: chargeMappingForm.chargeMappingUploadTypeId
        };

        var djsConfig = {
            params: {
                CreatedBy: sessionStorage.getItem('EID').toString(),
                UserId: sessionStorage.getItem('UserID').toString(),
                UploadTypeId: UPLOAD_TYPES.ChargeTypeUpload,
                VendorName: vendorOptions?.find(i => i.Key == chargeMappingForm.vendorId)?.Value.replace('[Preferred]', '').trim(),
                ChargeTypeDetails: JSON.stringify({
                                ...baseParams,
                            }), 
            },

            maxFiles: CHARGE_MAPPING_FILE_LIMITATION.maxFiles,
            minFiles: CHARGE_MAPPING_FILE_LIMITATION.minFiles,
            acceptedFiles: CHARGE_MAPPING_FILE_LIMITATION.acceptedFiles,
            dictInvalidFileType: this.toLocaleLanguage('error_invalid_file_type'),
            dictMaxFilesExceeded: this.toLocaleLanguage('error_exceeded_maximum_file'),
            dictErrorOccured: this.toLocaleLanguage('error_occured_reupload_file')
        };

        return djsConfig;
    }

    handleExtractChargeMapping = async (e)  => {
        this.setState({
            filterLoading: true,
            loadingLabel: "Downloading"
        })
        if (window.confirm(this.toLocaleLanguage('export_alert_message'))) {
            await this.props.extractChargeMapping().then(()=>{ 
                this.setState({
                    filterLoading:false,
                    loadingLabel:""
                })
            });
        }else {
            this.setState({
                filterLoading:false,
                loadingLabel:""})
        }   
    }

    toggleExtractErrorModal = (isShow, title, message) => {
        const { errorModal } = this.state;
        this.setState({
            errorModal: {
                ...errorModal,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });
    }

    handleCloseNotif = () => {
        this.toggleExtractErrorModal(false);
        store.dispatch(actions.change('chargeMappingForm.extractError', false));
    }

    disabledUpload = () => {
        const { chargeMappingForm } = this.props;
        const intialField = !(!chargeMappingForm.vendorId && !chargeMappingForm.chargeMappingUploadTypeId);

        let validFiles = false;
        if (this.childRef.current) {
            validFiles = this.childRef.current.checkValidFileForm();
        }
        
        return !(intialField && validFiles);
    }

    dropDragDisable = () => {
        const { chargeMappingForm } = this.props;
        const intialField = !(chargeMappingForm.vendorId && chargeMappingForm.chargeMappingUploadTypeId);

        return intialField;
    }

    handleUpload = ()=>{
        if (this.childRef.current) {
            this.childRef.current.processQueue();
        }
        this.setState({
            uploadInProgress: true
        });
    }

    handleDrop = () => {
        this.setState({
            isFileDropped: true,
        });
    };

    onErrorUpload = () =>{
        this.setState({
            uploadInProgress: false
        })
    }

    render() {
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InvoiceInvoiceUploadDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.InvoiceInvoiceUploadDashboardRW])

        const { chargeMappingForm } = this.props;
        const { vendorOptions, chargeMappingUploadTypeOptions } = this.props.chargeMappingUpload;

        return (
            <div className="invoice-upload"> 
                {
                    this.state.filterLoading &&
                    <Loading customClass="filter-loading" label={this.state.loadingLabel}/>	
                }
                <div className="invoice-mapping-container">
                
                <div className="field-section">
                    <div className="field-content">
                        <NotificationModal
                            show={this.state.errorModal.show}
                            title={this.state.errorModal.title}
                            message={this.state.errorModal.message}
                            handleModal={this.handleCloseNotif}
                            customClass={'comment-notification-modal modal-text-bold notification-footer'}
                        />

                        <Translation
                            getOnlyText={true}
                            onChangeTranslation={this.onChangeExtractAlertMsg}
                            translationKey={"export_alert_message"} />
                        <CustomSearchableSelectWrapper
                            label={`${this.toLocaleLanguage('vendor')}`}
                            options={vendorOptions}
                            selected={chargeMappingForm.vendorId}
                            onChange={(e) => this.handleChangeVendor(e)}
                            requiredField
                            placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                            fieldProp='chargeMappingForm.vendorId'
                            tagName='vendorDetailId'
                            optionLabelKey={{
                                Key: 'Key',
                                Value: 'Value'
                            }}
                            maxLength={MAX_LENGTH.limit_255}
                        />
                        <div className="spacer" />
                        <CustomSearchableSelectWrapper
                            label={`${this.toLocaleLanguage('upload_type')}`}
                            options={chargeMappingUploadTypeOptions}
                            selected={chargeMappingForm.chargeMappingUploadTypeId}
                            onChange={(e) => this.handleChangeUploadType(e)}
                            requiredField
                            placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                            fieldProp='chargeMappingForm.chargeMappingUploadTypeId'
                            tagName='chargeMappingUploadTypeId'
                            optionLabelKey={{
                                Key: 'Key',
                                Value: 'Value'
                            }}
                            maxLength={MAX_LENGTH.limit_255}
                        />
                        {chargeMappingForm.chargeMappingUploadTypeId == CHARGE_MAPPING_UPLOAD_TYPES.New ?
                            <span className="upload-type-note">Note: Upload type = New will replace all the existing charge mapping uploaded</span>
                            : null
                        }

                        {chargeMappingForm.chargeMappingUploadTypeId == CHARGE_MAPPING_UPLOAD_TYPES.Add ?
                            <span className="upload-type-note">Note: Upload type = Add will only add the uploaded data on the current set of charge mapping</span>
                            : null
                        }
                        
                        <div className="spacer" />
                        {isReadAndWrite || isReadAndExtractOnly ?
                            <div className="btn-container-extract" >
                                <ButtonIcon
                                    onClick={this.handleExtractChargeMapping}
                                    iconLeft="cloud-arrow-down"
                                    iconSize="17px"
                                    customClassName="header-option-list header-filter-button"
                                    labelName="Extract Charge Mapping"
                                    isDisable={!chargeMappingForm.vendorId}
                                />
                            </div>
                         : null} 
                    </div>
                </div>

                <div className="upload-section">
                    <div className="upload-content">
                        <DragDropUpload
                            ref={this.childRef}
                            buttonLabel={"Download Charge Mapping Template"}
                            disabled={this.dropDragDisable() || this.state.uploadInProgress}
                            downloadButton={this.handleDownloadTemplate}
                            djsConfigParams={this.djsConfigParams()}
                            onSuccessProcess={this.handleSuccessProcess}
                            onAddFiles={this.handleAddFiles}
                            onRemoveFiles={this.handleRemoveFiles}
                            onErrorUpload={this.onErrorUpload}
                            uploadTypeId={UPLOAD_TYPES.ChargeTypeUpload}
                        />
                    </div>
                </div>
                    {isReadAndWrite ?
                        <div className="upload-btn-section">
                            <div className="save-btn-container">
                                <Button disabled={this.disabledUpload() || this.state.uploadInProgress} onClick={this.handleUpload} className="upload-button">Upload</Button>
                            </div>
                        </div>
                        : null} 

                </div>

            </div>
            
        );
    }
}

export default connect(
    state => {
        const {
            chargeMappingUpload,
            translation
        } = state;

        const { chargeMappingForm } = state.form;

        return {
            chargeMappingUpload,
            chargeMappingForm,
            ...translation
        }
    },
    dispatch => bindActionCreators(
        Object.assign({}, chargeMappingAction),
        dispatch
    ) 

)(ChargeMappingView);